// extracted by mini-css-extract-plugin
export default {"content":"styles_content__lnAlJ","table":"styles_table__g7Vvx"};